module.exports = __webpack_public_path__ + "static/media/chevron-right-grey.8e36a225.svg";